import { render } from "./umiChat.vue?vue&type=template&id=2be7d00d&scoped=true&ts=true"
import script from "./umiChat.vue?vue&type=script&lang=ts"
export * from "./umiChat.vue?vue&type=script&lang=ts"

import "./umiChat.vue?vue&type=style&index=0&id=2be7d00d&lang=less&scoped=true"
import "./umiChat.vue?vue&type=style&index=1&id=2be7d00d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be7d00d"]])

export default __exports__